import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { ResponseData } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { AuthService } from 'src/app/helper/service/auth.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { AuthApiService } from '../../service/auth-api.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  mode: 'FORGOT' | 'CHANGE' | 'FORCE_CHANGE' = 'CHANGE';
  showSection: 'OTP' | 'CHANGE' | 'USERNAME' = 'CHANGE';
  dataForm: UntypedFormGroup = {} as UntypedFormGroup;
  title: string = 'Change Password';
  sub_title: string = 'Type your password'; //'Type Email/Mobile to recover password.';
  error_info: string | any = '';
  loading: boolean = false;
  isModal: boolean = false;
  public onClose: Subject<boolean> = new Subject();
  constructor(private authApi: AuthApiService,
    private auth: AuthService,
    private modelService: ModalService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.changeSegment();
    this.initForm();
  }
  
  
  setInput(data: any) {
    this.mode = data.mode;
    this.isModal = true;
    this.changeSegment();
    this.initForm();
    if(data.user_id){
      this.dataForm.patchValue({user_id:data.user_id});
    }else{
      this.dataForm.patchValue({user_id:this.auth.currentUserValue.user_id || ''});
    }
  }
  
  changeSegment(status: any = '') {
    if (status) {
      this.showSection = status;
    } else if (this.mode == 'FORGOT') {
      this.showSection = 'USERNAME';
    } else {
      this.showSection = 'CHANGE';
    }
    // this.initForm();
  }

  initForm() {
    const oldValidator = this.mode =='CHANGE' ? [Validators.required]:[];
    this.dataForm = new UntypedFormGroup({
      user_id: new UntypedFormControl(null, [Validators.required]),
      old_password: new UntypedFormControl('', oldValidator),
      password: new UntypedFormControl('', [Validators.required, matchValidator('confirm_password', true)]),
      confirm_password: new UntypedFormControl('', [matchValidator('password')])
    })
  }

  apiPayload() {
    const apiPayload = this.dataForm.value;
    apiPayload.mode = this.mode;
    return apiPayload;
  }


  changePassword() {
    this.error_info = '';
    if (this.dataForm.valid) {
      this.loading = true;
      this.authApi.changePassword(this.apiPayload()).then((res: ResponseData | any | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.close();
        }
      }).catch(err => {
      }).finally(() => this.loading = false);
    }
  }

  close(status = true) {
    if (this.isModal) {
      this.modelService.close();
      this.onClose.next(status);
    }
  }

}

export function matchValidator(
  matchTo: string,
  reverse?: boolean
): ValidatorFn {
  return (control: AbstractControl):
    ValidationErrors | null => {
    if (control.parent && reverse) {
      const c = (control.parent?.controls as any)[matchTo] as AbstractControl;
      if (c) {
        c.updateValueAndValidity();
      }
      return null;
    }
    return !!control.parent &&
      !!control.parent.value &&
      control.value ===
      (control.parent?.controls as any)[matchTo].value
      ? null
      : { matching: true };
  };
}